module.exports = __webpack_public_path__ + "assets/img/btn-more-b3db5864.png";